export default __webpack_public_path__ + "static/media/ProductSans-Regular.ac23817f.ttf";